module.exports = __webpack_public_path__ + "img/icon-arrow-gray-down.e393ef52.svg";